import React, { useEffect, useState } from "react";
import { getJourneyTeams } from "../../../../services/crm/salesJourney";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function SearchJourneyTeam({ journeyID, onSelectUser }) {
  const { reload } = useGlobalData();
  const [teams, setTeams] = useState([]);
  useEffect(() => {
    getJourneyTeamsData(journeyID);
  }, [journeyID, reload]);
  return (
    <CustomDataTableSearch
      data={teams}
      onRefreshData={() => {
        getJourneyTeamsData(journeyID);
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectUser(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectUser(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "User ID",
          field: "ID",
          body: null,
          sortable: true,
        },
        {
          header: "Username",
          field: "userName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.userName} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Description",
          field: "description",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.description} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
      ]}
    />
  );

  async function getJourneyTeamsData(journeyID) {
    const response = await getJourneyTeams(journeyID);
    const { data } = response.data;
    setTeams(data.teams);
  }
}

export default SearchJourneyTeam;
